module.exports = __webpack_public_path__ + "assets/img/icon_not_record_audio.4e36c84a.png";